module.exports = __webpack_public_path__ + "static/img/pingan.9f680d6e.png";